/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import {
  RevenueCardComponent,
  RevenueCardData,
} from "../revenue-card/revenue-card.component";

@Component({
  selector: "app-analytics-setup-required",
  imports: [CommonModule, ButtonModule, RevenueCardComponent],
  templateUrl: "./analytics-setup-required.component.html",
  styleUrl: "./analytics-setup-required.component.scss",
})
export class AnalyticsSetupRequiredComponent {
  // Mock data matching the actual revenue dashboard (from Screenshot_303.png)
  mockRevenueCards: RevenueCardData[] = [
    {
      title: "ALL REVENUE",
      amount: 11403.98,
      percentageChange: 72.35,
      orders: 258,
      ordersChange: 74.17,
      aov: 44.2,
      aovChange: 7.04,
      colorClass: "all-revenue",
    },
    {
      title: "SUBSCRIPTION",
      amount: 11035.58,
      percentageChange: 72.02,
      orders: 248,
      ordersChange: 74.82,
      aov: 44.49,
      aovChange: 11.12,
      colorClass: "subscription",
    },
    {
      title: "NON-SUBSCRIPTION",
      amount: 368.4,
      percentageChange: -79.59,
      orders: 10,
      ordersChange: -28.57,
      aov: 36.84,
      aovChange: -71.43,
      colorClass: "non-subscription",
    },
  ];

  /**
   * Opens the HelpScout Beacon for support
   */
  openSupportBeacon(): void {
    // Check if HelpScout Beacon is available
    if (typeof window !== "undefined" && (window as any).Beacon) {
      (window as any).Beacon("open");
    } else {
      // Fallback to mailto if Beacon is not available
      window.location.href = "mailto:support@autoship.cloud";
    }
  }
}
